@if (product?.relatedServiceItems.length>0) {
  <div class="pdp-iampp-heading">
    {{product?.relatedServiceItemsLabel}} {{ product.code }}
  </div>
  <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig"
    style="max-width: 98.7vw; width: 100%">
    @for (product of product?.relatedServiceItems; track product) {
      <div ngxSlickItem class="slide">
        <div class="pdp-iampp-items">
          <a [routerLink]="{  cxRoute: 'product',params: product?.target } | cxUrl" class="cx-product-image-container"
            tabindex="-1">
            <cx-media class="cx-product-image pdp-carousal-image"
              [container]="product.target.images?.PRIMARY||product.target.images" format="product"
            [alt]="product.target.summary||product.target.name"></cx-media>
          </a>
          <a [routerLink]="{  cxRoute: 'product',params: product?.target } | cxUrl" class="productCode">{{
          product.target.code }}</a>
          <p class="productTypeNumber">{{ product.target.typenumber }}</p>
          <p class="productName">{{ product.target.name }}</p>
          @if (product.sapEan) {
            <p class="productName">GTIN : {{product.target.sapEan}}</p>
          }
          <p class="productStatuscode">
            @if (product.target.salesStatus?.indexOf('common.') < 0) {
              <span>
              {{ product.target.salesStatus }}</span>
            }
            @if (product.target.salesStatus?.indexOf('common.') > -1) {
              <span>
              {{ product.target.salesStatus}}</span>
            }
          </p>
          <p class="productMarketType">{{ product.target.marketType }}</p>
          @if (product.target.replacedByProductCode && product.target.replaceByText) {
            <p class="productReplaceBy">
              {{'common.pdp_information_replacedby'|cxTranslate}} <a class="replaceByTextPDP" [class.active]="product?.target?.replacedByPDPUrl"
            [href]="product.target.replacedByPDPUrl">{{product.target.replacedByProductCode}}</a></p>
          }
        </div>
      </div>
    }
  </ngx-slick-carousel>
}
